import { useContext } from "react";
import { Context } from "./Context";

export const useProvider = () => {
  const store = useContext(Context);
  return store;
};